import  { useEffect, useState } from 'react'
import { Typography, Button, Box } from '@mui/material';
import Pending from "../../img/kycpending1.png"
import SuccessVerification from "../../img/kyc/successVerification.png"
import DocumentSigned from "../../img/kyc/documentSigned.png"
import InitialVerification from "../../img/kyc/initialVerification.png"
import Voided from "../../img/kyc/Voided.png"
import DocumentPending from "../../img/kyc/documentPending.png"
import DocuementCancelled from "../../img/kyc/docuementCancelled.png"
import RejectedVerification from "../../img/kyc/rejectedVerification.png"
import FaxIcon from "../../img/kyc/faxIcon.png"
import { ShimmerSkeleton } from '../../utils/SkimmerSkeleton';
import { ApiService } from '../../API/AxiosInstance';
import { colors } from '../../Theme/tokens';

export default function Docusign({docusignClicked, setDocusignClicked}) {
    const [status, setStatus] = useState('')
    const [ownerStatus, setownerStatus] = useState('')
    const [url, setUrl] = useState('')
    const [loading, setloading] = useState(true)
    const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ""

    const getAgreementStatus = async(fromDocusignStatus) => {
        await ApiService().get(`users/${userId}/agreements`).then(res => {
            if(res?.data && Object.keys(res?.data?.userDocsAgreementInfo)?.includes('signerSigningStatus')) {
                setStatus(res?.data?.userDocsAgreementInfo?.signerSigningStatus)
                setownerStatus(res?.data?.userDocsAgreementInfo?.ownerSigningStatus)  
                if(fromDocusignStatus) getAgreementUrl()
            } 
        })
            .catch(err => {
                setloading(false)
            })
    }
    useEffect(() => {
        getAgreementStatus()
        getAgreementUrl()
    },[])

    const getAgreementUrl = async() => {
        await ApiService().get(`users/${userId}/agreements/sign`).then(res => {
            setUrl(res.data.url)
            setloading(false)
        })
            .catch(err => {
                setloading(false)
            })
    }


    const gotourl = () => {
        if(url) window.open(url, '_blank');
    }

    const handleClick = () => {
        setDocusignClicked(false)
       if(localStorage.getItem('docusignStatus')) localStorage.removeItem('docusignStatus')
    }

  return (
    <Box sx={{ backgroundColor: colors.background.default, width: loading? '100%' : 'fit-content', alignSelf: docusignClicked ? "center" : "flex-start", height: "100%", borderRadius: loading ? '0' : '24px' }}>
       {loading ? (
        <Box sx={{ width: '157px', height: "134px", display: "flex", alignItems: "center", justifyContent: "start" }}>
        <ShimmerSkeleton  sx={{width:"100%", height:"100%",}} />
    </Box>
       ) : (
        status && (status == "declined") ? (
            docusignClicked ? (
          
                <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:'white'}}>
                <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                    <Box 
                    sx={{alignItems:'center', alignSelf:'center', backgroundColor:'white'}}
                    component={'img'}
                    src={RejectedVerification}
                    height={'150px'}
                    width={'auto'}
                    />
                </Box>
                <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                    <Typography variant='h5_1' sx={{ color: colors.text.primary, alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600' }} >Declined!</Typography>
                    <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >The recipient declined to sign the document</Typography>
                </Box>
                <Button  onClick={handleClick} sx={{fontWeight:"500",width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                Back
                </Button>
            </Box>
            ) :(
                <Box onClick={() => setDocusignClicked(true)} sx={{cursor:"pointer", padding:"15px 30px", backgroundColor:colors.background.default, width:"fit-content", borderRadius:"24px", display:"flex", flexDirection:"column", gap:"10px"}}>
                <Box component='img' sx={{alignSelf:"center", width:"60px", height:"60px"}} src={DocuementCancelled} />
                <Typography  sx={{ fontWeight:"500", fontSize:"11px", color:colors.text.primary, lineHeight:"12px", textAlign:"center"}}>Document Declined</Typography>
                </Box> 
             )
            
        ) : 
        status && (status == "completed" && ownerStatus == "completed") ? (
            docusignClicked ? (<Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:'white'}}>
                 <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                     <Box 
                     sx={{alignItems:'center', alignSelf:'center', backgroundColor:'white'}}
                     component={'img'}
                     src={SuccessVerification}
                     height={'150px'}
                     width={'auto'}
                     />
                 
                 </Box>
                 <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                     <Typography variant='h5_1' sx={{ color: colors.text.primary, alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600' }} >Signing Completed</Typography>
                     <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >The recipient has signed the document.</Typography>
                 </Box>
                 <Button  onClick={handleClick} sx={{fontWeight:"500", mt:4,width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                 Back
                 </Button>
             </Box>
             ) : (
                    <Box  onClick={() => setDocusignClicked(true)} sx={{cursor:"pointer", padding:"15px 30px", backgroundColor:colors.background.default, width:"fit-content", borderRadius:"24px", display:"flex", flexDirection:"column", gap:"10px"}}>
                    <Box component='img' sx={{alignSelf:"center", width:"60px", height:"60px"}} src={DocumentSigned} />
                    <Typography  sx={{ fontWeight:"500", fontSize:"11px", color:colors.text.primary, lineHeight:"12px", textAlign:"center"}}>Document Signed</Typography>
                    <Typography  sx={{cursor:"pointer", fontWeight:"400", fontSize:"9px", color:colors.primary.main, lineHeight:"12px", textAlign:"center"}}>View Now</Typography>
                    </Box> 
                 )
          
         ) 
        :
        status && (ownerStatus == "created" && status !='completed') ? (
            docusignClicked ? (
          
                <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:'white', alignItems:"center"}}>
                <Box sx={{display:'flex', flexDirection:'column', gap:'10px', alignSelf:"center"}}>
                    <Box 
                    sx={{alignItems:'center', alignSelf:'center', backgroundColor:'white'}}
                    component={'img'}
                    src={InitialVerification}
                    height={'150px'}
                    width={'auto'}
                    />
                
                </Box>
                <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                    <Typography variant='h5_1' sx={{ color: colors.text.primary, alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600' }} >Sign Now </Typography>
                    <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >The recipient has not signed document</Typography>
                </Box>
             <Button  onClick={gotourl} sx={{fontWeight:"500", mt:4,width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                Sign Now
                </Button>
                <Button  onClick={handleClick} sx={{fontWeight:"500",width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                    Back
                </Button>
            </Box>
            ) :(
                <Box  onClick={() => setDocusignClicked(true)} sx={{cursor:"pointer", padding:"15px 30px", backgroundColor:colors.background.default, width:"fit-content", borderRadius:"24px", display:"flex", flexDirection:"column", gap:"10px"}}>
                <Box component='img' sx={{alignSelf:"center", width:"60px", height:"60px"}} src={DocumentSigned} />
                <Typography  sx={{ fontWeight:"500", fontSize:"11px", color:colors.text.primary, lineHeight:"12px", textAlign:"center"}}>Document Created</Typography>
                <Typography  sx={{cursor:"pointer", fontWeight:"400", fontSize:"9px", color:colors.primary.main, lineHeight:"12px", textAlign:"center"}}>View Now</Typography>
                </Box> 
             )
            
        ) :
        status && (status == 'voided' || ownerStatus == 'voided') ? (
            docusignClicked ? (
             <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:'white'}}>
                 <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                     <Box 
                     sx={{alignItems:'center', alignSelf:'center', backgroundColor:'white'}}
                     component={'img'}
                     src={RejectedVerification}
                     height={'150px'}
                     width={'auto'}
                     />
                 </Box>
                 <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                     <Typography variant='h5_1' sx={{ color: colors.text.primary, alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600' }} >Voided</Typography>
                     <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >TradeTogether has voided the document.</Typography>
                 </Box>
                 {url && <Button  onClick={gotourl} sx={{fontWeight:"500", mt:4,width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                 View
                 </Button>}
                 <Button  onClick={handleClick} sx={{fontWeight:"500",width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                 Back
                 </Button>
             </Box>
            ) : (<Box onClick={() => setDocusignClicked(true)} sx={{cursor:"pointer", padding:"15px 30px", backgroundColor:colors.background.default, width:"fit-content", borderRadius:"24px", display:"flex", flexDirection:"column", gap:"10px"}}>
             <Box component='img' sx={{alignSelf:"center", width:"60px", height:"60px"}} src={Voided} />
             <Typography  sx={{ fontWeight:"500", fontSize:"11px", color:colors.text.primary, lineHeight:"12px", textAlign:"center"}}>Document Voided</Typography>
             <Typography sx={{cursor:"pointer", fontWeight:"400", fontSize:"9px", color:colors.primary.main, lineHeight:"12px", textAlign:"center"}}>View</Typography>
             </Box> )
         ) :
        status && (status =="created" || status =="sent" || status == "delivered" || status =="completed" || ownerStatus == "sent" || ownerStatus == "delivered") ? (
            docusignClicked ? (
          
                <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:'white', alignItems:"center"}}>
                <Box sx={{display:'flex', flexDirection:'column', gap:'10px', alignSelf:"center"}}>
                    <Box 
                    sx={{alignItems:'center', alignSelf:'center', backgroundColor:'white'}}
                    component={'img'}
                    src={Pending}
                    height={'150px'}
                    width={'auto'}
                    />
                
                </Box>
                <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                    <Typography variant='h5_1' sx={{ color: colors.text.primary, alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600' }} >Pending </Typography>
                    <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >{status =="completed" == true ? 'Your signed document is under proccess' :'The recipient has not signed document.'}</Typography>
                </Box>
             {ownerStatus !='completed' && <Button  onClick={gotourl} sx={{fontWeight:"500", mt:4,width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                View Now
                </Button>}
                <Button  onClick={handleClick} sx={{fontWeight:"500",width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                    Back
                </Button>
            </Box>
            ) :(<Box onClick={() => setDocusignClicked(true)} sx={{cursor:"pointer",padding:"15px 30px", backgroundColor:colors.background.default, width:"fit-content", borderRadius:"24px", display:"flex", flexDirection:"column", gap:"10px"}}>
            <Box component='img' sx={{alignSelf:"center", width:"60px", height:"60px"}} src={DocumentPending} />
            <Typography  sx={{ fontWeight:"500", fontSize:"11px", color:colors.text.primary, lineHeight:"12px", textAlign:"center"}}>Document Pending</Typography>
            <Typography  sx={{cursor:"pointer", fontWeight:"400", fontSize:"9px", color:colors.primary.main, lineHeight:"12px", textAlign:"center"}}>View Now</Typography>
            </Box> )
            
        ) :    status && (status == 'faxPending' || ownerStatus == 'faxPending') ? (
            docusignClicked ? (
             <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:'white'}}>
                 <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                     <Box 
                     sx={{alignItems:'center', alignSelf:'center', backgroundColor:'white'}}
                     component={'img'}
                     src={FaxIcon}
                     height={'150px'}
                     width={'auto'}
                     />
                 </Box>
                 <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                     <Typography variant='h5_1' sx={{ color: colors.text.primary, alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600' }} >Fax Pending</Typography>
                     <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >Recipient has a fax pending.</Typography>
                 </Box>
                 {url && <Button  onClick={gotourl} sx={{fontWeight:"500", mt:4,width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                 View
                 </Button>}
                 <Button  onClick={handleClick} sx={{fontWeight:"500",width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                 Back
                 </Button>
             </Box>
            ) : (<Box onClick={() => setDocusignClicked(true)} sx={{cursor:"pointer", padding:"15px 30px", backgroundColor:colors.background.default, width:"fit-content", borderRadius:"24px", display:"flex", flexDirection:"column", gap:"10px"}}>
             <Box component='img' sx={{alignSelf:"center", width:"60px", height:"60px"}} src={Voided} />
             <Typography  sx={{ fontWeight:"500", fontSize:"11px", color:colors.text.primary, lineHeight:"12px", textAlign:"center"}}>Fax Pending</Typography>
             <Typography sx={{cursor:"pointer", fontWeight:"400", fontSize:"9px", color:colors.primary.main, lineHeight:"12px", textAlign:"center"}}>View</Typography>
             </Box> )
         ) : (            
            status && (status == "declined" || ownerStatus == 'declined') ? (
               docusignClicked ? (
                <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:'white'}}>
                    <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                        <Box 
                        sx={{alignItems:'center', alignSelf:'center', backgroundColor:'white'}}
                        component={'img'}
                        src={RejectedVerification}
                        height={'150px'}
                        width={'auto'}
                        />
                    </Box>
                    <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                        <Typography variant='h5_1' sx={{ color: colors.text.primary, alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600' }} >Declined!</Typography>
                        <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >The recipient declined to sign the document</Typography>
                    </Box>
                    <Button  onClick={handleClick} sx={{fontWeight:"500",width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                    Back
                    </Button>
                </Box>
               ) : (<Box onClick={() => setDocusignClicked(true)} sx={{cursor:"pointer", padding:"15px 30px", backgroundColor:colors.background.default, width:"fit-content", borderRadius:"24px", display:"flex", flexDirection:"column", gap:"10px"}}>
                <Box component='img' sx={{alignSelf:"center", width:"60px", height:"60px"}} src={DocuementCancelled} />
                <Typography  sx={{ fontWeight:"500", fontSize:"11px", color:colors.text.primary, lineHeight:"12px", textAlign:"center"}}>Document Declined</Typography>
                <Typography sx={{cursor:"pointer", fontWeight:"400", fontSize:"9px", color:colors.primary.main, lineHeight:"12px", textAlign:"center"}}>Sign Again</Typography>
                </Box> )
            ) 
            : (
                docusignClicked ? (
                    <Box sx={{display:'flex', flexDirection:'column', gap:'20px', py:2, backgroundColor:'white'}}>
                        <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                            <Box 
                            sx={{alignItems:'center', alignSelf:'center', backgroundColor:'white'}}
                            component={'img'}
                            src={RejectedVerification}
                            height={'150px'}
                            width={'auto'}
                            />
                        </Box>
                        <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                            <Typography variant='h5_1' sx={{ color: colors.text.primary, alignItems:'center', alignSelf:'center', fontSize:'25px', fontWeight:'600' }} >Exception Occurred!</Typography>
                            <Typography variant='h5_1' sx={{ color: colors.text.secondary, alignItems:'center', alignSelf:'center', fontSize:'18px', fontWeight:'400' }} >An exception has occurred on the server during the signing session</Typography>
                        </Box>
                        <Button  onClick={handleClick} sx={{fontWeight:"500",width:'100%', fontSize: '15px', height: '42px',  padding: '10px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: "white", backgroundColor: colors.primary.main, '&:hover': {backgroundColor: colors.primary.main}, maxWidth:"394px", display:"flex", alignSelf:"center" }} >
                        Back
                        </Button>
                    </Box>
                   ) : (<Box onClick={() => setDocusignClicked(true)} sx={{cursor:"pointer", padding:"15px 30px", backgroundColor:colors.background.default, width:"fit-content", borderRadius:"24px", display:"flex", flexDirection:"column", gap:"10px"}}>
                    <Box component='img' sx={{alignSelf:"center", width:"60px", height:"60px"}} src={DocuementCancelled} />
                    <Typography  sx={{ fontWeight:"500", fontSize:"11px", color:colors.text.primary, lineHeight:"12px", textAlign:"center"}}>Document Exception</Typography>
                    </Box> )
            )
                
        )

       )}
    </Box>
    
  )
}
